<template>
  <div>
    <AdminNavLinks v-if="isAdmin" />
    <NavLinks v-else />
  </div>
</template>

<script>
import NavLinks from '@/components/customer/NavLinks';
import AdminNavLinks from '@/components/admin/NavLinks';

export default {
  name: 'NavBarDesktop',
  components: { NavLinks, AdminNavLinks },
  props: {
    isAdmin: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
};
</script>
